import { apiBase } from '../axios-client';
import { OMS_LOCKER_CODE_PATH } from '../../constants/paths';

export const getLockerCode = (request: any, cookie: string) => {
  return apiBase.post(OMS_LOCKER_CODE_PATH, request, {
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
      Cookie: cookie,
    },
  });
};
